import { getTestOverrides } from '@wix/cli-test-overrides';

export function debounceQueue<T extends unknown[]>(
  func: (args: T[]) => void,
  wait: number
): (...args: T) => void {
  const { debounceQueueWait } = getTestOverrides();

  let argsArray: T[] = [];
  let timeout: NodeJS.Timeout;

  return (...args: T) => {
    argsArray.push(args);

    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func(argsArray);
      argsArray = [];
    }, debounceQueueWait ?? wait);
  };
}
